export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./locale.vue?vue&type=template&id=e632226c&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/locale.vue?vue&type=template&id=e632226c&
// module id = 1288
// module chunks = 0